module.exports = __webpack_public_path__ + "static/media/check.d8254704.svg";